export default __webpack_public_path__ + "74bca5ba43a5b48d7dab37578dcd421a.png";